import React, { FormEvent, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { fetchAndMapAssetsAndStatuses } from "../helpers/apiHelper";
import { AssetsResponse } from "../types/statusTypes";

interface SearchFormProps {
  fetchData: (func: Promise<AssetsResponse>) => Promise<void>;
}

export default function SearchForm({ fetchData }: SearchFormProps) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [search, setSearch] = useState(searchParams.get("search") ?? "");

  function onSearch(event: FormEvent) {
    event.preventDefault();
    fetchData(fetchAndMapAssetsAndStatuses({ search }));
    setSearchParams({ search });
  }

  return (
    <form className="w-25 mb-3 d-flex gap-3 ps-3" onSubmit={onSearch}>
      <label className="visually-hidden" htmlFor="search">Search</label>
      <input
        className="form-control"
        type="text"
        id="search"
        placeholder="Type to search..."
        value={search}
        onChange={event => setSearch(event.target.value)}
      />
      <button className="btn btn-primary" type="submit">Search</button>
    </form>
  );
}
